module.exports = __webpack_public_path__ + "img/truck-blue.0be2585f.svg";